<fgb-mobile-page-header
  [pageTitle]="'wallet.claimed.page.title'"
  backButtonLink="/rewards/wallet"
  [showQr]="false"
  [showBalance]="false"
/>
<div class="mobile-container">
  <div class="container pt-lg-0 pt-3">
    <div class="align-items-center pt-3 d-lg-flex d-none">
      <div class="py-3">
        <div class="text-white cursor-pointer d-none d-lg-flex btn-circle-gloss bg-glass" [routerLink]="'/rewards/wallet'">
          <span class="material-icons pe-1">arrow_back_ios_new</span>
        </div>
      </div>
    </div>

    <!-- Offer history -->
    <ng-container *ngIf="campaignOffers$ | async as featuredCampaigns">
      <ng-container *ngIf="hasOfferItems">
        <div class="d-flex align-items-center justify-content-center mb-3 w-100">
          <h5 class="m-0 wallet-redeemed-title text-uppercase text-white">
            {{ 'wallet.redeemed.offers.history.title' | translate }}
          </h5>
          <div class="mb-4">
            <fgbcl-campaigns-offers-used-list
              [usedOffers]="featuredCampaigns.CampaignsAndEntitlements"
            ></fgbcl-campaigns-offers-used-list>
          </div>
        </div>
      </ng-container>
    </ng-container>

    <!-- Items history -->
    <div class="d-flex align-items-center justify-content-center mb-3 w-100">
      <h5 class="m-0 wallet-redeemed-title text-uppercase text-white">{{ 'wallet.claimed.history.title' | translate }}</h5>
    </div>
    <ng-container
      *ngIf="
        {
          walletItemsClaimed: walletItemsClaimed$ | async,
        } as walletItems;
        else noWalletItems
      "
    >
      <ng-container *ngIf="walletItems.walletItemsClaimed && walletItems.walletItemsClaimed.length; else noWalletItems">
        <fgbcl-rewards-wallet-redeemed-list [redeemedItems]="walletItems.walletItemsClaimed"></fgbcl-rewards-wallet-redeemed-list>
      </ng-container>
    </ng-container>
  </div>
</div>

<ng-template #noWalletItems>
  <div class="rounded">
    <div class="font-size-12 text-center no-wallet-items text-white rounded py-3">
      {{ 'claimed.rewards.placeholder.description' | translate }}
    </div>
  </div>
</ng-template>
